import { render, staticRenderFns } from "./local_menu_group_link.vue?vue&type=template&id=4d2d8e59"
import script from "./local_menu_group_link.vue?vue&type=script&lang=js"
export * from "./local_menu_group_link.vue?vue&type=script&lang=js"
import style0 from "./local_menu_group_link.vue?vue&type=style&index=0&id=4d2d8e59&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d2d8e59')) {
      api.createRecord('4d2d8e59', component.options)
    } else {
      api.reload('4d2d8e59', component.options)
    }
    module.hot.accept("./local_menu_group_link.vue?vue&type=template&id=4d2d8e59", function () {
      api.rerender('4d2d8e59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/local_menu_group_link.vue"
export default component.exports